// Loan status enum values matching backend
export const LOAN_STATUS = {
    PENDING: 'PENDING',
    IN_WITHDRAWAL: 'IN_WITHDRAWAL',
    WITHDRAWAL_PASSED: 'WITHDRAWAL_PASSED',
    PAYMENT_CONFIRMED: 'PAYMENT_CONFIRMED',
    PAID: 'PAID',
    CONSULTANT_BILLED: 'CONSULTANT_BILLED',
    CANCELLED: 'CANCELLED'
};
